var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};


if($('#preloader').length > 0) {  
$(window).on('load', function() {
$( "#preloader" ).delay(350).fadeOut( "slow", function() {
if($('.preloader-overflow').length > 0) {
$('body').removeClass('preloader-overflow');   
}
});
});
}
if($('.media-slick-slider  .thumbnail-list').length > 0) {  
$('.thumbnail-list').not('.slick-initialized').slick({
  vertical: true,
  verticalSwiping: true,
  slidesToShow: 4,
  slidesToScroll: 1
});
}




$(window).scroll(function() {    
  if($(window).width() > "1024"){
  if ( $(window).scrollTop() >= 500 ) {
    $('.sticky-bar').css('display', 'flex');
    } else {
    $('.sticky-bar').css('display', 'none');
    }
}});


$(window).scroll(function(){
if($(window).width() < "1024"){
  if ($(window).scrollTop() >= 900) {
        $('.sticky-bar').css('display', 'flex');
    } else {
    $('.sticky-bar').css('display', 'none');        
    }
}
});


$(document).ready(function(){
  $("#recently").click(function(){
    $("#recently-viewed-products").slideToggle(750);
  });
});


var afterInfiniteLoaded = function afterInfiniteLoaded() {   
 $('.loading-image').removeClass('loading-image').addClass('loaded-image');
  }  
if ($('.pagination-method-loadmore_btn').length > 0) {
        var AjaxMethod = 'click';
    } else {
        var AjaxMethod = 'scroll';
    }
if ($('.collection #AjaxinatePagination').length > 0) {
var endlessScroll = new Ajaxinate({
    container: '.AjaxinateContainer',
    pagination: '#AjaxinatePagination',
    method: AjaxMethod,
   offset: 0,
   callback: afterInfiniteLoaded
  
});
}





InitCustomFunctions();
function InitCustomFunctions() { 
if($('.toggleFilter').length > 0) {  
const filter = document.querySelector(".toggleFilter");
const sidebar = document.querySelector(".facets-vertical");
const closeDiv = document.querySelector(".close-sidebar")  

filter.addEventListener("click", () => {
  filter.classList.toggle("active");
  sidebar.classList.toggle("open");
});

closeDiv.addEventListener("click", () => {
  filter.classList.remove("active");
  sidebar.classList.remove("open");
});
}

//product page color variant to select thumbnail img change color_variants
  if($('.show-grouped__variant').length > 0) {
$('input:radio[name="Color"]').click(function() {
  const cvariant = $(this).val();  
  $('input:radio[name="Color"]').next('.swatch-element').removeClass('clicked');
  $(this).next('.swatch-element').addClass('clicked');
  $('.slick-list').addClass('height_fix');
  $('.thumbnail-list__item').each(function() {
      const variant_val = $(this).find('img').attr("alt");
      if (cvariant == variant_val) {
          $(this).addClass('show');
          $(this).removeClass('hidden');
      } else {
          $(this).addClass('hidden');
          $(this).removeClass('show');
      }
  });
});
  }

  

//     Item swatch trigger start
$(document).off('click', '.color-values a').on('click', '.color-values a', function() {
    var $card = $(this).closest('.card-wrapper');
    $card.find('.color-values a').removeClass('active');
    $(this).addClass('active');
});

$(document).off('click', '.size-values a').on('click', '.size-values a', function() {
    if ($(this).hasClass("active")) {
        $(".size-values a").removeClass("active");
        $(this).parents('.products').find('.variant-option-size .size-values').removeClass('active');
    } else {
        $(".size-values a").removeClass("active");
        $(this).addClass("active");
        $(this).parents('.products').find('.variant-option-size .size-values').removeClass('active');
    }
});
$('body').off('click', '.color-values-plus a').on('click', '.color-values-plus a', function(e) {
    $(this).parents('.variant-option-color').find('.show-on-click').css('display', 'flex');
    $(this).parents('.color-values-plus').css('display', 'none');
    e.preventDefault();
});

$('body').off('click', '.swatch-element.color').on('click', '.swatch-element.color', function () {
  $(this).next('label').find('i');
});
$('body').off('click', '.swatch span').on('click', '.swatch span', function () {
  var $span = $(this);
  var $card = $span.closest('.card-wrapper');

  // update card image
  var newImage = $span.data('image');
  if (newImage) {
    $card.find('.card__inner .motion-reduce').attr('src', newImage).attr('srcset', newImage);
  }

  if ($span.closest('.swatch').hasClass('color')) {
    var variantId  = $span.data('id');
    var available  = $span.data('available');  // true / false
    var variantUrl = $span.data('variant-url');

    // update ATC hidden input
    $card.find('.variant-push').val(variantId);

    // update all product links to point at this variant
    if (variantUrl) {
      const baseUrl = $card.find('a.full-unstyled-link').attr('href').split('?')[0];

      const variantId = $span.data('id');

      const cleanUrl = baseUrl + '?variant=' + variantId;

      $card.find('a.full-unstyled-link').attr('href', cleanUrl);
    }

    // update ATC button state + text + type + data attrs
    var $atcBtn = $card.find('.quick-add__submit, .fvdvfdfdf');
    var productTitle = $card.find('.full-unstyled-link').first().text().split(' - ')[0].trim();
    var variantTitle = $span.data('variant-title') || '';
    var variantUrl = $span.data('variant-url') || '';
    var notifyProduct = productTitle + (variantTitle ? ' — ' + variantTitle : '');
    var notifySubject = 'Back in stock: ' + productTitle + (variantTitle ? ' – ' + variantTitle : '');
    var notifyBody = 'Notify me when ' + productTitle + ' (' + variantTitle + ') is back. Link: ' + variantUrl;

    if (available) {
      $atcBtn.attr('type', 'submit').attr('name', 'add')
        .prop('disabled', false)
        .removeClass('notify-me-trigger')
        .removeAttr('data-notify-product data-notify-subject data-notify-body');
      $atcBtn.find('.js-btn-text').text('More Details');
    } else {
      $atcBtn.attr('type', 'button').removeAttr('name')
        .prop('disabled', false)
        .addClass('notify-me-trigger')
        .attr('data-notify-product', notifyProduct)
        .attr('data-notify-subject', notifySubject)
        .attr('data-notify-body', notifyBody);
      $atcBtn.find('.js-btn-text').text('Bring This Back');
    }

    // update variant title in card heading
    var colorName = $span.data('color-name');
    if (colorName) {
      $card.find('.js-variant-title').text(colorName);
    }

    // update price display
    var newPriceFormatted = $span.data('price-formatted');
    var newCompareFormatted = $span.data('compare-at-price-formatted');
    var newPrice = parseInt($span.data('price') || 0);
    var newCompare = parseInt($span.data('compare-at-price') || 0);
    var isOnSale = available && newCompare > newPrice && newCompare > 0;
    if (newPriceFormatted) {
      var $priceEl = $card.find('.product-price-current');
      $priceEl.toggleClass('price--on-sale', isOnSale);
      $priceEl.toggleClass('price--sold-out', !available);
      $priceEl.find('.price__regular .price-item--regular').text(newPriceFormatted);
      $priceEl.find('.price__sale .price-item--sale').text(newPriceFormatted);
      $priceEl.find('.price__sale s.price-item--regular').text(newCompareFormatted || '');
    }

    // update wishlist button variant ID so wishlist state reflects selected variant
    var $wishlistBtn = $card.find('.add-wishlist');
    if ($wishlistBtn.length) {
      $wishlistBtn.attr('data-variant_id', variantId);
      var wishHandle = $wishlistBtn.attr('data-product_handle');
      var wishList = new dT_WhistList();
      var wishKey = wishList.getKey(wishHandle, String(variantId));
      if (wishList.isAdded(wishKey)) {
        $wishlistBtn.addClass('added');
      } else {
        $wishlistBtn.removeClass('added');
      }
    }

    // close global modal if open
    $('#global-notify-modal').prop('hidden', true);
    $('body').removeClass('notify-modal-open');

    // update sold-out / sale badges
    var compareAtPrice = parseInt($span.data('compare-at-price') || 0);
    var price = parseInt($span.data('price') || 0);
    var onSale = available && compareAtPrice > price && compareAtPrice > 0;
    $card.find('.js-sold-out-badge').prop('hidden', available);
    $card.find('.js-sale-badge').prop('hidden', !onSale);

    // toggle sold-out classes on card wrapper
    $card.toggleClass('card-wrapper--sold-out', !available);
    $card.find('.card').toggleClass('card--sold-out', !available);

    // size swatch active state filter
    var swatch_item = $span.data('variant-item');
    $card.find('.variant-option-size .size-values').removeClass('active');
    $card.find('.variant-option-size .swatch').each(function () {
      var swatch_size_vars = $(this).find('span').data('variant-title');
      if (!swatch_size_vars) return;
      swatch_size_vars = $.map(swatch_size_vars.split('/'), $.trim);
      swatch_size_vars = $.map(swatch_size_vars, function(n) { return n.toLowerCase().replace(/ /g, '-'); });
      if ($.inArray(swatch_item, swatch_size_vars) >= 0) {
        $(this).parent('.size-values').toggleClass('active');
      }
    });
  }

  if ($span.closest('.swatch').hasClass('size')) {
    var variant = $span.data('id');
    $card.find('.variant-push').val(variant);
  }
});


  
//     Item swatch trigger end

// Notify Me — populate global modal and open
$(document).off('click', '.notify-me-trigger').on('click', '.notify-me-trigger', function(e) {
  // Check if button is inside a quick-view modal-opener
  if ($(this).closest('modal-opener').length > 0) {
    return; // Quick view button hai, toh kuch mat karo
  }
  e.preventDefault();
  var $cardBtn = $(this);
  var $modal = $('#global-notify-modal');
  if (!$modal.length) return;
  // reset form + UI state
  var $form = $modal.find('#global-notify-form');
  $form.show().trigger('reset');
  $modal.find('.notify-me-modal__submit').show().prop('disabled', false).text('Bring This Back');
  $modal.find('.notify-me-success').prop('hidden', true);
  // populate hidden fields from card button data (use .attr() not .data() — .data() caches initial value)
  $modal.find('#notify-modal-product-name').text($cardBtn.attr('data-notify-product') || '');
  $modal.find('#notify-modal-subject').val($cardBtn.attr('data-notify-subject') || '');
  $modal.find('#notify-modal-body').val($cardBtn.attr('data-notify-body') || '');
  // open
  $modal.prop('hidden', false);
  $modal.find('#notify-modal-email-global').val('').focus();
  $('body').addClass('notify-modal-open');
  // fire focusin on form so Shopify lazily loads its captcha library NOW (before user hits submit)
  $form[0].dispatchEvent(new Event('focusin', { bubbles: true }));
});

// Notify Me — close modal
$(document).off('click', '.notify-me-modal__close, .notify-me-modal__backdrop').on('click', '.notify-me-modal__close, .notify-me-modal__backdrop', function() {
  $('#global-notify-modal').prop('hidden', true);
  $('body').removeClass('notify-modal-open');
});

// Close on Escape
$(document).off('keydown.notifyModal').on('keydown.notifyModal', function(e) {
  if (e.key === 'Escape') {
    $('#global-notify-modal').prop('hidden', true);
    $('body').removeClass('notify-modal-open');
  }
});

// Notify Me — AJAX submit
// Strategy: override form.submit() so when Shopify's captcha calls it after verification,
// we intercept and do fetch() instead of native page navigation.
$(document).off('click', '.notify-me-modal__submit').on('click', '.notify-me-modal__submit', function(e) {
  e.preventDefault();

  var $btn     = $(this);
  var $modal   = $('#global-notify-modal');
  var $form    = $modal.find('.notify-contact-form');
  var $email   = $modal.find('#notify-modal-email-global');
  var $success = $modal.find('.notify-me-success');
  var form     = $form[0];

  if (!form || !$email.length) return;

  var emailVal = ($email.val() || '').trim();
  if (!emailVal || emailVal.indexOf('@') < 0) {
    $email.focus();
    return;
  }

  $btn.prop('disabled', true).text('Verifying…');

  function doAjax() {
    $btn.text('Sending…');
    fetch('/contact', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
    .then(function(res) {
      if (res.ok) {
        $form.hide();
        $success.prop('hidden', false);
        setTimeout(function() {
          $modal.prop('hidden', true);
          $('body').removeClass('notify-modal-open');
          $form.show().trigger('reset');
          $btn.prop('disabled', false).text('Bring This Back');
          $success.prop('hidden', true);
        }, 3000);
      } else {
        $btn.prop('disabled', false).text('Bring This Back');
      }
    })
    .catch(function() {
      $btn.prop('disabled', false).text('Bring This Back');
    });
  }

  // Override form.submit: Shopify captcha calls form.submit() after filling h-captcha-response
  var origSubmit = form.submit;
  var safetyTimer = setTimeout(function() {
    // Captcha took too long or failed — restore and unblock
    form.submit = origSubmit;
    $btn.prop('disabled', false).text('Bring This Back');
  }, 30000);

  form.submit = function() {
    clearTimeout(safetyTimer);
    form.submit = origSubmit;
    doAjax();
  };

  // Dispatch submit event — Shopify captcha intercepts it, prevents default,
  // runs verification async, then calls form.submit() with token filled in.
  var notIntercepted = form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));

  if (notIntercepted) {
    // No captcha intercepted the event (captcha not active/loaded) — submit directly
    clearTimeout(safetyTimer);
    form.submit = origSubmit;
    doAjax();
  }
  // else: captcha is running — form.submit() override will fire when done
});

  

$(".custom-product-grid li").click(function(){
var classNames = "list-view-filter grid--2-col-desktop grid--3-col-desktop grid--4-col-desktop grid--5-col-desktop grid--6-col-desktop";
var getCols = $(this).data('cols');
$('.custom-product-grid li').removeClass('active');
$(this).addClass("active");
$('ul#product-grid').removeClass(classNames).addClass(getCols);  
});
if($('.filter-buttons').length > 0) {
const viewExists = document.querySelector('.grid-view-button');
if (viewExists.classList.contains('layout-mode')) {
const listViewButton = document.querySelector('.list-view-button');
const gridViewButton = document.querySelector('.grid-view-button');
const list = document.querySelector('ul.view-mode');
const gridviewlist = document.querySelector('.custom-product-grid');

listViewButton.onclick = function () {
listViewButton.classList.add('active');
gridViewButton.classList.remove('active');
list.classList.remove('grid-view-filter');
list.classList.add('list-view-filter');
gridviewlist.classList.add('hidden');
}

gridViewButton.onclick = function () {
listViewButton.classList.remove('active');
gridViewButton.classList.add('active');
list.classList.remove('list-view-filter');
list.classList.add('grid-view-filter');
gridviewlist.classList.remove('hidden');
}

}
}
if($('#swiper-sidebar-carousel').length > 0) {
var swiper = new Swiper("#swiper-sidebar-carousel", {        
  navigation: {
    nextEl: "#swiper-sidebar-next",
    prevEl: "#swiper-sidebar-prev",
  },
});
}
 $('.loading-image').removeClass('loading-image').addClass('loaded-image');
}

//FBT ul li select box

$("ul.custom-select").on("click", "li:not(.init)", function() {
  var selectedVal = $(this).data('option-value');  
 // console.log(selectedVal);
  $(this).parents('.fbt-product__meta').find(".selectVariant option").attr("selected",false);
  $(this).parents('.fbt-product__meta').find(".selectVariant option[value="+selectedVal+"]").attr("selected","selected").trigger('change');
}); 

$("ul.custom-select").on("click", ".init", function() {
    $(this).closest("ul.custom-select").children('li:not(.init)').toggle();
});

$("ul.custom-select").on("click", "li:not(.init)", function() {
    $(this).parent().children('li:not(.init)').removeClass('selected');
    $(this).addClass('selected');
    $(this).parent().children('.init').html($(this).html());
    $(this).parent().children('.init').removeClass('li-unselected');
    $(this).parent().children('li:not(.init)').toggle();
    if($('ul.custom-select li.init').hasClass("li-unselected")) {
      $('#add-frequently-bought').prop('disabled', true);
    } else {
      $('#add-frequently-bought').prop('disabled', false);
    }
});
loadedBg();
function loadedBg() {
window.onload=function(){
setTimeout(function(){
 $('.loading-image').removeClass('loading-image').addClass('loaded-image');
}, 500);
    }  
}

 jQuery(function () {
  jQuery().on("click", function () {
    jQuery('iframe').contents().find('video').each(function () {
      this.currentTime = 0;
      this.pause();
    });
  });
});

// Cart error toast
document.addEventListener('cart:add:error', function(e) {
  var msg = (e.detail && e.detail.message) ? e.detail.message : 'Something went wrong. Please try again.';
  var $toast = $('#pdp-cart-error-toast');
  if (!$toast.length) {
    $toast = $('<div id="pdp-cart-error-toast"></div>').css({
      position: 'fixed',
      bottom: '24px',
      left: '50%',
      transform: 'translateX(-50%)',
      background: '#1a1a1a',
      color: '#fff',
      padding: '14px 24px',
      borderRadius: '8px',
      fontSize: '14px',
      zIndex: 99999,
      maxWidth: '90vw',
      textAlign: 'center',
      boxShadow: '0 4px 16px rgba(0,0,0,0.3)',
      display: 'none',
      whiteSpace: 'nowrap'
    }).appendTo('body');
  }
  $toast.text(msg).stop(true, true).fadeIn(300).delay(4000).fadeOut(300);
});


